import { ReactNode } from "react";

export function Email({
  email,
  className,
  children,
}: {
  email: string | null | undefined;
  className?: string;
  children?: ReactNode;
}) {
  if (!email) {
    return null;
  }

  return (
    <a
      href={`mailto:${email}`}
      className={className}
      target="_blank"
      rel="noreferrer"
      title={email}
    >
      {children ?? email}
    </a>
  );
}
